import { languages } from "../../../dummyData/dummyData";
import TileItemInfo from "../../molecules/TileItemInfo/TileItemInfo";
import TileItemImgInfo from "../../molecules/TileItemImgInfo/TileItemImgInfo";
import TileItem from "../TileItem/TileItem";
import { generatePath, useHistory } from "react-router-dom";
import { Routes } from "../../../routes";
import { ACTIONS, PopupsContext } from "../../../contexts/PopupsContext";
import { popupFields } from "../../templates/LearningEventsTemplate/LearningEventsTemplate";
import { learningEventsRepository } from "../../../repository/learningEvents.repository";
import { useContext, useEffect } from "react";
import useFetch from "../../../hooks/useFetch";
import { competencesRepository } from "../../../repository/competences.repository";
import { currencyFormat, dateFormat } from "../../../utils/formatters";

const LearningEventTile = ({ data }) => {
  const { id, profile_image_small, name, category, date, location, learningArea, level, language, price, organizatorName, organizatorImg, details_url, canEdit } = data;
  const { callPopup, setIsDataActive } = useContext(PopupsContext);
  let history = useHistory();

  const fetchCompetences = useFetch();
  useEffect(() => {
    if (fetchCompetences.isReady) {
      setIsDataActive(true);
      callPopup({
        type: ACTIONS.FORM,
        payload: {
          header: `${languages.EN.labels.edit} ${languages.EN.labels.learningEvent}`,
          fields: popupFields(fetchCompetences.data, {
            ...data,
            competences: data.competence_levels.map((competence_level) => `${competence_level.competence.id}-${competence_level.level}`)
          }),
          postAction: (formData) => learningEventsRepository.editLearningEvent(id, formData),
        },
      });
    }
  }, [fetchCompetences.isReady]);

  return (
    <TileItem title={name} subtitle={category} image={profile_image_small} buttons={[
      {
        icon: "url",
        onClick: () => window.open(details_url, '_blank'),
        tooltip: languages.EN.labels.goToPage,
      },
      {
        icon: "calendar2",
        onClick: () => callPopup({
          type: ACTIONS.POST_CONFIRM,
          payload: {
            header: languages.EN.labels.confirmation,
            content: languages.EN.messages.addToCalendar,
            action: () => learningEventsRepository.sendCalendarEvent(id),
          },
        }),
        tooltip: languages.EN.labels.addToCalendar,
      },
    ].concat(canEdit ? [
      {
        icon: "edit",
        onClick: () => {
          setIsDataActive(false);
          fetchCompetences.fetchData(competencesRepository.getCompetences());
          callPopup({ type: ACTIONS.LOADING });
        },
        tooltip: languages.EN.labels.edit,
      },
      {
        icon: "garbage",
        onClick: () => callPopup({
          type: ACTIONS.DELETE,
          payload: {
            type: languages.EN.labels.learningEvent,
            elementName: name,
            action: () => learningEventsRepository.deleteLearningEvent(id),
          },
        }),
        tooltip: languages.EN.labels.delete,
      },
    ] : []).concat([
      {
        icon: "dots",
        onClick: () => history.push(generatePath(Routes.learningEventDetails.base, { id: id })),
        tooltip: languages.EN.labels.details,
      },
    ])}>
      <TileItemInfo header={languages.EN.labels.date} value={dateFormat(date)} />
      <TileItemInfo header={languages.EN.labels.location} value={location} />
      <TileItemInfo header={languages.EN.labels.learningArea} value={learningArea} />
      <TileItemInfo header={languages.EN.labels.level} value={languages.EN.enums.experienceLevels[level]} />
      <TileItemInfo header={languages.EN.labels.language} value={languages.EN.enums.languages[language]} />
      <TileItemInfo header={languages.EN.labels.price} value={currencyFormat(price)} />
      <TileItemImgInfo header={languages.EN.labels.organizer} value={organizatorName} image={organizatorImg} />
    </TileItem>
  );
};

export default LearningEventTile;
